import { memo, useEffect, useMemo, useState } from "react";
import { Security } from "../../proto/generated/candle-data-depot-common";
import { Box, Stack, StackProps, Typography } from '@mui/material'
import { useSelector } from "react-redux";
import { getSecurityAsync, getSecurityKey } from "../../util/security";
import SecurityLogo from "../securityLogo/securityLogo";
import CompanyEvents from "../CompanyEvents/companyEvents";
import { selectCustomizedColumns } from "../../selectors/user";

export type SymbolDisplayProps = {
    securityList: Security[],
    expression: string,
    expressionMode: boolean,
    expressionName?: string,
    logoSize?: number,
    fontSize?: number,
    spacing?: StackProps["spacing"],
    maxWidth?: StackProps["maxWidth"]
    displayLogo?: boolean,
    displayTitle?: boolean
    displayEvents?: boolean
    onPopoverOpenChange?: (isOpen: boolean) => void;
}

const SymbolDisplay: React.FC<SymbolDisplayProps> = ({
    securityList,
    expression,
    expressionMode,
    expressionName,
    displayLogo = true,
    displayTitle = true,
    displayEvents = true,
    logoSize = 12,
    fontSize = 12,
    spacing = 1,
    maxWidth = '190px',
    onPopoverOpenChange
}) => {

    const [securities, setSecurities] = useState<Security[]>([])
    const keys = useMemo(() => securityList?.map(v => getSecurityKey(v.exchange, v.code)).filter(Boolean).join(',') ?? '', [securityList])
    useEffect(() => {
        if (!keys) { setSecurities([]); return }
        const keyList = keys.split(',').filter(Boolean)
        Promise.all(keyList.map((k) => getSecurityAsync(k))).then(setSecurities)
    }, [keys])
    const companyName = useMemo(() => expressionName || securities[0]?.symbol || '', [expressionName, securities])
    const customColumnWatchList=useSelector(selectCustomizedColumns)

    return <Stack direction={'row'} spacing={spacing} alignItems={'center'} maxWidth={maxWidth}>
        {customColumnWatchList.showLogo && displayLogo && <SecurityLogo
            securityList={securities}
            expression={expression || ''}
            expressionMode={expressionMode}
            expressionName={expressionName ?? ''}
            fontSize={fontSize}
            size={logoSize}
        />}
        {displayTitle && <Typography noWrap variant={'body2'} sx={{ lineHeight: '24px' }}>
            {companyName ?? ''}
        </Typography>}
        {displayEvents &&
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <CompanyEvents companyCode={securities[0]?.companyCode ?? ''} onPopoverOpenChange={onPopoverOpenChange}/>
            </Box>}
    </Stack>;
}


export default memo(SymbolDisplay)